import React from "react";

const AddButton = ({ title, Icon, className = "", onClick }) => {
    return (
        <button onClick={onClick} className={`flex items-center gap-3 px-4 py-2 rounded-md bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-100 ${className}`}>
            {Icon && <Icon size={22} />}
            <span>{title}</span>
        </button>
    );
};

export default AddButton;